import React from 'react'
import BasicModal from '../GlobalComponents/BasicModal'
import { useState } from "react"
import { Box, IconButton, InputAdornment, OutlinedInput, FormControl, InputLabel } from "@mui/material"
import { showToast } from "../GlobalComponents/Toast"
import { FormField } from "../GlobalComponents/Fields"
import { useSelector } from 'react-redux'
import { changePassword } from '../../services/userServices'
import Loader from '../GlobalComponents/Loader'
import { Visibility, VisibilityOff } from '@mui/icons-material'

function ChangePasswordModal(props) {
    const { _id } = useSelector((state) => state.app.userData)
    const [isLoading, setIsLoading] = useState(false)
    const [currentPassword, setCurrentPassword] = useState("")
    const [password, setPassword] = useState("")
    const [confirmPassword, setConfirmPassword] = useState("")
    const [showPassword, setShowPassword] = useState(false)
    const [showCurrentPassword, setShowCurrentPassword] = useState(false)
    const [showConfirmPassword, setShowConfirmPassword] = useState(false)

    const { selectedModal, setSelectedModal } = props

    const onSubmit = async () => {
        if (!currentPassword || !password || !confirmPassword || password !== confirmPassword) return showToast("error", "Please fill and match the passwords")
        setIsLoading(true)
        const data = await changePassword({ _id, currentPassword, password })
        setIsLoading(false)
        if (data?.status !== "Success") {
            let message = data.message
            showToast("error", message)
        } else {
            showToast("info", "Password changed")
            onClose()
        }
    }

    const onClose = () => {
        setSelectedModal("")
    }

    const data = {
        ...props,
        title: "Change Password",
        show: true, onSubmit: onSubmit, onClose: onClose
    }

    return <BasicModal {...data}>
            {isLoading && <Loader />}
            <Box p={2}>
            <FormControl fullWidth size="small" sx={{ marginBottom: "10px" }}>
                <InputLabel htmlFor="currentPassword">Current Password</InputLabel>
                <OutlinedInput
                    id="currentPassword"
                    type={showCurrentPassword ? "text" : "password"}
                    value={currentPassword}
                    onChange={(e) => setCurrentPassword(e.target.value)}
                    label="Current Password"
                    required
                    endAdornment={
                        <InputAdornment position="end">
                            <IconButton
                                aria-label="toggle password visibility"
                                onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                            >
                                {showCurrentPassword ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                        </InputAdornment>
                    }
                />
            </FormControl>

            <FormControl fullWidth size="small" sx={{ marginBottom: "10px" }}>
                <InputLabel htmlFor="newPassword">New Password</InputLabel>
                <OutlinedInput
                    id="newPassword"
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    label="New Password"
                    required
                    endAdornment={
                        <InputAdornment position="end">
                            <IconButton
                                aria-label="toggle password visibility"
                                onClick={() => setShowPassword(!showPassword)}
                            >
                                {showPassword ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                        </InputAdornment>
                    }
                />
            </FormControl>

            <FormControl fullWidth size="small">
                <InputLabel htmlFor="confirmPassword">Confirm Password</InputLabel>
                <OutlinedInput
                    id="confirmPassword"
                    type={showConfirmPassword ? "text" : "password"}
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    label="Confirm Password"
                    required
                    endAdornment={
                        <InputAdornment position="end">
                            <IconButton
                                aria-label="toggle password visibility"
                                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                            >
                                {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                        </InputAdornment>
                    }
                />
            </FormControl>
        </Box>
    </BasicModal>
}

export default ChangePasswordModal